import styled from 'styled-components';
export const ThirdPartyLoginWrapper = styled.div.withConfig({
  displayName: "LoginOptionsstyles__ThirdPartyLoginWrapper",
  componentId: "mv5y1z-0"
})(["display:flex;gap:10px;margin-bottom:12px;button{overflow:hidden;margin-left:0px;}@media (min-width:450px){button{width:49% !important;div{padding-right:0;}}}@media (max-width:449px){flex-wrap:wrap;}"]);